<!--
    Summary:
        hkml.exhibition.web - contact-us-right
    ChangeLog:
        wangn on 2020/11/29 added
-->
<template>
  <div class="v-contact-us-right" title="contact-us-right">
    <div class="info">
      <div class="info-item">
        <img class="icon" src="../../assets/images/contact/right-1.png"/>
        <span class="text">
          {{$t('footText.address_prefix')}}<br />
          {{$t('footText.address_suffix')}}
<!--          {{ $t('ContactUsText.p3_address')}}-->
        </span>
      </div>
      <div class="info-item">
        <img class="icon" src="../../assets/images/contact/right-2.png"/>
        <span class="text">{{$t('ContactUsText.p3_tel')}}</span>
      </div>
    </div>
    <div class="info">
      <div class="info-item">
        <img class="icon" src="../../assets/images/contact/right-3.png"/>
        <span class="text">{{$t('ContactUsText.p3_email')}}</span>
      </div>
      <div class="info-item">
        <img class="icon" src="../../assets/images/contact/right-4.png"/>
        <span class="text">{{$t('ContactUsText.p3_fax')}}</span>
      </div>
    </div>
    <div class="map">
      <img src="../../assets/images/contact/mdmap.svg"/>
    </div>
  </div>
</template>

<script>
  export default {
    name: "contact-us-right"
  }
</script>

<style scoped lang="scss">
  .v-contact-us-right {
    width: 30vw;
    text-align: left;
    margin-top: 7.5vw;

    .info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 1vw;
      padding-left: 2px;

      .info-item {
        padding-right: 1vw;
        display: flex;
        flex-shrink: 0;
        align-items: center;


        &:first-child{
          width: 55%;
        }
        .icon {
          margin-right: .5vw;
          width: 2vw;
          height: 2vw;
        }
      }
    }

    .map {
      img {
        width: 100%;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/contact/contact-us-right.vue